<template>
  <div>
    <a-form-model layout="horizontal" :colon="false" :model="form" :rules="formRules" ref="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
        <a-form-model-item label="是否新保" prop="isNewPolicy" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-select v-model="form.isNewPolicy" @change="isNewPolicyChange" :disabled="disabledAll">
                <a-select-option value="Y">是</a-select-option>
                <a-select-option value="N">否</a-select-option>
            </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="form.isNewPolicy === 'N'" label="上年保单号" prop="lastYearPolicyNo" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.lastYearPolicyNo" :disabled="disabledAll"></a-input>
        </a-form-model-item>
        <a-form-model-item label="渠道佣金率" prop="agentRate" :wrapper-col="{ lg: 6, sm: 8 }">
            <a-input v-model="form.agentRate" suffix="%" :disabled="disabledAll"></a-input>
        </a-form-model-item>
        <a-form-model-item label="上传询价资料" :extra="disabledAll ? '' : '上传资料需要包括：目标方案、人员清单、过往赔付数据及上一年度保单等'">
            <div class="file-list">
                <a v-for="item in allFiles" :href="item.url" :key="item.fileName" target="_blank">{{item.fileName}}</a>
            </div>
            <a-button type="primary" @click="openUpload" v-if="!disabledAll">上传</a-button>
        </a-form-model-item>
    </a-form-model>
    <a-modal
        class="form-layout" :mask-closable="false"
        :visible="isUploadFileShow" :title="''" :footer="null"
        width="500px" @cancel="handleCancel"
    >
        <a-upload-dragger
            :file-list="fileList"
            name="file"
            :multiple="true"
            action="/"
            :remove="handleRemove"
            :beforeUpload="beforeUpload"
        >
            <p>拖动文件到该区域或点击上传文件</p>
        </a-upload-dragger>
        <div class="upload-btns">
            <a-button type="primary" ghost @click="handleCancel">取消</a-button>
            <a-button type="primary" @click="uploadSubmit" :disabled="!fileList || !fileList.length">确定上传</a-button>
        </div>
    </a-modal>
  </div>
</template>

<script>

export default {
    props: {
        inquiryInformation: {
            type: String,
            required: true
        },
        formData: {
            required: true,
            type: Object
        },
        disabledAll: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            isUploadFileShow: false,
            form: {
                isNewPolicy: 'Y',
                agentRate: ''
            },
            allFiles: [],
            fileList: [],
            formRules: {
                lastYearPolicyNo: [
                    {required: true, message: '是否新保为否时，请输入上年保单号！'}
                ],
                agentRate: [
                    {required: true, message: '渠道佣金率必填！'},
                    {pattern: /^([1-9][0-9]*|0)([.][0-9]+)?$/, message: '请输入正确的渠道佣金率（10%需输入10）！'}
                ]
            }
        }
    },
    watch: {
        formData: {
            deep: true,
            handler: function(val) {
                if (val) {
                    const { fileUrls, ...form} = val
                    this.form = form
                    this.allFiles = fileUrls
                }
            }
        }
    },
    methods: {
        // 是否新保修改为是后清空上年保单号内容
        isNewPolicyChange(val) {
            if (val === 'Y') {
                this.lastYearPolicyNo = undefined
            }
        },
        // 向父组件提交数据
        submitHandler() {
            return new Promise((resolve, reject) => {
                this.$refs.form.validate(valid => {
                    if (!valid){
                        reject(new Error())
                        return false;
                    }
                    const { isNewPolicy, agentRate, lastYearPolicyNo } = this.form
                    resolve(this.form)
                    this.$emit('collectData', { isNewPolicy, agentRate, lastYearPolicyNo })
                })
            })
        },
        // 打开文件上传弹窗
        openUpload() {
            this.fileList = []
            this.isUploadFileShow = true
        },
        // 收集文件数据 取消自动上传
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];
            return false;
        },
        // 点击确定上传按钮
        uploadSubmit() {
            this.allFiles = []
            for(let i = 0; i < this.fileList.length; i ++) {
                let formData = new FormData()
                formData.append('fileStream', this.fileList[i])
                formData.append('inquiryInformation', this.inquiryInformation)
                formData.append('fileName', this.fileList[i].name)
                formData.append('fileType', 'tiananTeamUploads')
                this._uploadGroupAFP(formData, i)
            }
            this.handleCancel()
        },
        // 移除选择的文件
        handleRemove(file){
            for(let i = 0; i< this.fileList.length; i ++) {
                if (this.fileList[i].uid === file.uid) {
                    this.fileList.splice(i, 1)
                    return true
                }
            }
        },
        // 关闭弹窗
        handleCancel() {
            this.isUploadFileShow = false
        },
        // 上传文件接口
        _uploadGroupAFP(data, i) {
            this.$api.uploadGroupAFP(data).then(res => {
                if (res.data.returnCode === '00') {
                    this.$set(this.allFiles, i, {
                        fileName: this.fileList[i].name,
                        url: res.data.content
                    })
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
::v-deep .ant-form-extra,
.file-list a{
    display: block;
    color: #fa3d3d;
}
::v-deep .ant-upload{
    min-height: 120px;
    margin-top: 20px;
}
.upload-btns{
    text-align: center;
    .ant-btn{
        margin: 20px 10px 0;
    }
}
p{
    margin: 0;
}
</style>